import { graphql, useStaticQuery } from "gatsby";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { StaticDiningAreaCategoriesDataQuery } from "types/graphql-types";
import {
  LocalizedStaticQueryResult,
  localizeStaticQuery
} from "./localizeStaticQuery";

export type useStaticDiningAreaCategoryDataReturn = LocalizedStaticQueryResult<
  StaticDiningAreaCategoriesDataQuery["diningAreas"]["nodes"][0]
>[];

const useStaticDiningAreaCategoriesData = (): useStaticDiningAreaCategoryDataReturn => {
  const language = useLanguage();
  const { diningAreas } = useStaticQuery<StaticDiningAreaCategoriesDataQuery>(
    graphql`
      query StaticDiningAreaCategoriesData {
        diningAreas: allSanityDiningAreaCategory(
          sort: { order: ASC, fields: card___title___en }
        ) {
          nodes {
            _id
            id
            fullPath
            i18nFullPaths
            metadata {
              tracking {
                name
              }
            }
            card {
              ...AsCardForStaticQuery
            }
          }
        }
      }
    `
  );

  return localizeStaticQuery(diningAreas.nodes, language);
};

export default useStaticDiningAreaCategoriesData;
